<div class="chart-container">
  @if (data?.length > 0 && !isMaterialChart) {
    <p class="chart-title">{{ chartTitle }}</p>
  }
  <div [style.width]="isStacked ? '100%' : '690px'" [style.height]="chartHeight">
    <canvas #canvas>Browser does not support canvas.</canvas>
  </div>
</div>

@if (isBarChartLoder) {
  <div class="custom-table-list-row-main">
    <div class="custom-col-width-100 text-danger d-flex justify-content-center">
      <app-common-icon [loadingIcon]="true"></app-common-icon>
    </div>
  </div>
}

@if ((!data || data.length === 0) && !isBarChartLoder) {
  <div class="color-red chart-records">
    @if (!showNoDataFound) {
      <p>The Storage is currently Empty</p>
    }
    @if (showNoDataFound) {
      <p>No Data Found !</p>
    }
  </div>
}